import { createAction, props } from "@ngrx/store";
import { InitialDataModel } from "./state";
import { OkModel } from "src/app/model/ok.model";
import { PersonalDetailsModel } from "src/app/model/member-details.model";

export const CreateLeadRequestAction = createAction('[Initial Data Form] create lead request',
    props<{ data: InitialDataModel }>());
export const CreateLeadResponseAction = createAction('[Initial Data Form] create lead response',
    props<{ data: OkModel<boolean> }>());
export const ResetDataSavedAction = createAction('[Initial Data Form] reset data saved property');

export const SetDataFromDetailsStepAction = createAction('[Initial Data Form] set changed data from details step', props<{data:PersonalDetailsModel}>())